import axios from 'axios'

export default {
    deleteClientRecord(recordId, companyId) {
        return axios.delete(`/company-client/record/${recordId}`, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    addNewClientRecord(request, companyId) {
        return axios.post(
            '/company-client/record',
            { ...request },
            {
                headers: {
                    'x-tenant-id': companyId,
                },
            },
        )
    },

    editClientRecord(request, recordId, companyId) {
        return axios.put(
            `/company-client/record/${recordId}`,
            { ...request },
            {
                headers: {
                    'x-tenant-id': companyId,
                },
            },
        )
    },

    getCompanyClientById(clientId, companyId) {
        return axios.get(`/company-client/company-client/${clientId}`, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    getKeys(companyId) {
        return axios.get(`/company-client/record/keys`, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },
}
